import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { shadows } from "../../../design-system/tokens/shadows";

export const Card = styled.div`
  position: fixed;
  ${popoverMotion()}
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  padding: ${spacing[5]};
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  box-shadow: ${shadows.elevation[3]};
  width: 20rem;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  background: none;
  color: ${rawColors.text.mediumEmphasis};
  border-radius: ${borderRadius.sm};
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${rawColors.structural[100]};
    color: ${rawColors.text.highEmphasis};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

export const MonthLabel = styled.div`
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
  text-align: center;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: ${spacing[1]};
`;

export const WeekdayCell = styled.div`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
  text-align: center;
  padding: ${spacing[1]} 0;
`;

interface DayCellProps {
  $selected: boolean;
  $muted: boolean;
  $disabled: boolean;
}

export const DayCell = styled.button<DayCellProps>`
  ${typographyMixin("caption", 3)}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: ${({ $muted }) =>
    $muted ? rawColors.text.lowEmphasis : rawColors.text.highEmphasis};

  &:hover:not(:disabled) {
    background-color: ${rawColors.structural[100]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${rawColors.primary[900]};
      color: ${rawColors.text.white};
      &:hover:not(:disabled) {
        background-color: ${rawColors.primary[900]};
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
    `}
`;
